<template>
  <Train>
    <template #train>
      <TPMTaktarea
        v-for="(taktarea, taktarea_index) in getUObjects({type: 'taktareas', ids: train.taktareas})"
        :key="`taktareahover${taktarea.id}`"
        :draggable_disabled="draggable_disabled"
        :train="train"
        :train_index="train_index"
        :taktarea="taktarea"
        :taktarea_index="taktarea_index"
        :project_id="project_id"
        :new_milestone="new_milestone"
        :milestone_selection="milestone_selection"
        :snackbar="snackbar"
        @toggleDraggable="$emit('toggleDraggable', $event)"
      />
    </template>
  </Train>
</template>
<script>
  import { mapGetters, mapActions} from 'vuex';

  import Train from '@/components/ProjectTaktPlan/Train.component.vue';
  import TPMTaktarea from '@/views/Project/ProjectTaktPlanMobile/TPMTaktarea.wrapper.vue';

  export default {
    props: [
      'project_id',
      'train',
      'train_index',
      'draggable_disabled',
      'new_milestone',
      'milestone_selection',
      'snackbar',
    ],
    components: {
      Train,
      TPMTaktarea,
    },
    data: () => ({
    }),
    // updated() {
    //   console.log('tptrain updated');
    // },
    computed: {
      ...mapGetters('Ultra', [
        'getUObjects',
      ]),
      ...mapGetters('Project', [
        'isEditMode',
      ]),
    },
    methods: {
      ...mapActions('Ultra', [
        'updateUObjectPosition'
      ]),
    }
  }
</script>
<style>
  .class {

  }
</style>
